import { Toaster } from 'react-hot-toast'
import { Outlet } from 'react-router'
import logo from '../assets/acelera-logo.png'
import acelerafit from '../assets/login/acelerafit.png'
export default function LoginPage() {
  const getYear = new Date().getFullYear().toString()

  return (
    <main className="grid xl:grid-cols-[1fr_524px] 2xl:grid-cols-[1fr_824px]  w-full h-screen">
      <Toaster position="top-right" reverseOrder={false} toastOptions={{ duration: 3000 }} />
      <div className=" grid grid-rows-[1fr_104px] items-center h-full w-full">
        <Outlet />
        <footer className="flex bg-[#f6f6f6] min-w-full flex-grow h-full items-center justify-between px-24 text-sm">
          <div className="flex gap-2">
            <img src={logo} className="h-6" />
            <span>@AceleraFit</span>
          </div>

          <div className="text-[#6B7280]">
            <span>© AceleraFit {getYear}</span>
          </div>
        </footer>
      </div>
      <div className="bg-acelerait-black hidden xl:flex relative overflow-hidden ">
        <img src={acelerafit} alt="logo" className="w-full" />
      </div>
    </main>
  )
}
